var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 16,
    viewBox: "0 0 410 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0487 16C17.4281 7.0651 9.58465 0 0 0H410C400.415 0 392.572 7.0651 391.951 16H219.421C218.808 8.96054 212.586 3.42857 205 3.42857C197.414 3.42857 191.192 8.96054 190.579 16H18.0487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketup);
export default __webpack_public_path__ + "static/media/ticketup.a29fa6b4fcbe8cd1b3cfdd9caf3e1e71.svg";
export { ForwardRef as ReactComponent };